import StatusCard from 'components/Header/StatusCard';
import useAppSelector from 'hooks/useAppSelector';
import { useTranslation } from 'react-i18next';
import Flex from 'components/ui/Flex';
import { ReturnStatusStatistic, ReturnStatusType } from 'returnCenter-api';
import { returnSelectors } from 'store/reducers/returnSlice';
import { styled } from 'styled-components';

type ReturnStatusCardsProps = {
    statistics: ReturnStatusStatistic[] | null;
    completed: boolean;
    blocked: boolean;
    received: boolean;
    created: boolean;
    itemsSelected: boolean;
    incomingPackage: boolean;
    inprogress: boolean;
    creditError: boolean;
    creditedBatchPending: boolean;
    selectedStatus: ReturnStatusType | null;
    handleClick: (statusType?: ReturnStatusType, value?: number) => void;
};

export const RETURN_STATUS = [
    ReturnStatusType.Created,
    ReturnStatusType.ItemsSelected,
    ReturnStatusType.IncomingPackage,
    ReturnStatusType.Received,
    ReturnStatusType.InProgress,
    ReturnStatusType.OnHold,
    ReturnStatusType.CreditError,
    ReturnStatusType.CreditedBatchPending,
    ReturnStatusType.BatchHandled,
    ReturnStatusType.Completed,
];

const ReturnStatusCards = ({
    statistics,
    completed,
    blocked,
    inprogress,
    selectedStatus,
    handleClick,
    received,
    created,
    itemsSelected,
    incomingPackage,
    creditError,
    creditedBatchPending,
}: ReturnStatusCardsProps) => {
    const { t } = useTranslation();
    const b2cAttentionCount = useAppSelector(returnSelectors.selectB2CAttentionCount);

    return (
        <Wrapper gap="1rem" justify="center" align="center" className="return-status-cards w-100">
            {RETURN_STATUS?.map((status) => {
                const item = statistics?.find((stat) => stat.status === status);
                const warning =
                    status === ReturnStatusType.Completed && b2cAttentionCount > 0 ? t('b2c.attentionCard') : undefined;
                const isChanging =
                    (item?.status === ReturnStatusType.Completed && completed) ||
                    (item?.status === ReturnStatusType.OnHold && blocked) ||
                    (item?.status === ReturnStatusType.InProgress && inprogress) ||
                    (item?.status === ReturnStatusType.Received && received) ||
                    (item?.status === ReturnStatusType.IncomingPackage && incomingPackage) ||
                    (item?.status === ReturnStatusType.Created && created) ||
                    (item?.status === ReturnStatusType.ItemsSelected && itemsSelected) ||
                    (item?.status === ReturnStatusType.CreditError && creditError) ||
                    (item?.status === ReturnStatusType.CreditedBatchPending && creditedBatchPending);

                return (
                    <StatusCard
                        key={status}
                        statistics={item ? item : { status, value: 0 }}
                        onClick={() => handleClick(status, item?.value)}
                        isChanging={isChanging}
                        isSelected={selectedStatus === status}
                        noResults={item?.value === 0}
                        warning={warning}
                    />
                );
            })}
        </Wrapper>
    );
};

export default ReturnStatusCards;

const Wrapper = styled(Flex)`
    flex-wrap: wrap;

    @media (max-width: 832px) {
        justify-content: center;
    }
`;
